<template>
  <vs-popup
    title="Mobil Siparişler"
    fullscreen
    :active.sync="orderListIsActiveLocal"
  >
    <printer
      v-if="printeractive"
      ref="printer"
      :orderDetail="orderDetail"
      :orderEntries="orderDetail.cartEntries"
      :totalPrice="orderDetail.totalPrice"
      :totalDiscountPrice="orderDetail.totalCampaignDiscountAmount"
      :currentDateTime="currentDate"
      :activePersonal="''"
    />
    <vs-row>
      <vs-col vs-w="3"
        ><vs-button
          type="gradient"
          color="success"
          icon-pack="feather"
          icon="icon-refresh-cw"
          @click="getOrder()"
          >Manuel Yenile</vs-button
        ></vs-col
      >
      <vs-col vs-w="3"></vs-col>
      <vs-col vs-w="3"></vs-col>
    </vs-row>
    <div class="kanban-board">
      <div class="kanban-column">
        <h1>Bekliyor</h1>
        <vs-card
          v-for="order in orders"
          :key="order.integrationOrderId"
          v-if="order.orderStatus === 0"
        >
          <mobile-order-card
            :order="order"
            @show-PopupDetail2="showPopupDetail2"
            @show-popup="showPopup"
            :remainingTime="remainingTime(order.tableId)"
            :nextTitle="'Siparişi hazırlanıyora çek'"
            :nextStatus="1"
          />
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>Hazırlanıyor</h1>
        <vs-card
          v-for="order in orders"
          :key="order.integrationOrderId"
          v-if="order.orderStatus === 1"
        >
          <mobile-order-card
            :order="order"
            @show-PopupDetail2="showPopupDetail2"
            @show-popup="showPopup"
            :remainingTime="remainingTime(order.tableId)"
            :nextTitle="'Siparişi hazırlandıya çek'"
            :nextStatus="2"
          />
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>Hazır</h1>
        <vs-card
          v-for="order in orders"
          :key="order.integrationOrderId"
          v-if="order.orderStatus === 2"
        >
          <mobile-order-card
            :order="order"
            @show-PopupDetail2="showPopupDetail2"
            @show-popup="showPopup"
            :remainingTime="remainingTime(order.tableId)"
            :nextTitle="'Siparişi Kuryeye Teslim Et'"
            :nextStatus="4"
          />
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>Kuryede</h1>
        <vs-card
          v-for="order in orders"
          :key="order.integrationOrderId"
          v-if="order.orderStatus === 4"
        >
          <mobile-order-card
            :order="order"
            @show-PopupDetail2="showPopupDetail2"
            @show-popup="showPopup"
            :remainingTime="remainingTime(order.tableId)"
            :nextTitle="'Siparişi Teslim Et'"
            :nextStatus="3"
          />
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>Tamamlandı</h1>
        <vs-card
          v-for="order in orders"
          :key="order.integrationOrderId"
          v-if="order.orderStatus === 3"
        >
          <mobile-order-card
            :order="order"
            @show-PopupDetail2="showPopupDetail2"
            @show-popup="showPopup"
            :remainingTime="remainingTime(order.tableId)"
          />
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>İptal Edildi</h1>
        <vs-card
          v-for="order in orders"
          :key="order.integrationOrderId"
          v-if="order.orderStatus === -1"
        >
          <mobile-order-card
            :order="order"
            @show-PopupDetail2="showPopupDetail2"
            @show-popup="showPopup"
            :remainingTime="remainingTime(order.tableId)"
          />
        </vs-card>
      </div>

      <div
        fullscreen
        style="z-index: 9999999"
        class="popup-overlay"
        v-if="showPopupFlag"
      >
        <div fullscreen class="popup">
          <h3>İşlemi yapmak istediğinize eminmisiniz ?</h3>
          <p>Sipariş ID: {{ selectedOrder.integrationOrderId }}</p>

          <div v-if="selectedStatus === -1">
            <label for="cancelReason">İptal Sebebi Seçiniz:</label>
            <v-select
              id="cancelReason"
              v-model="cancelReasonString"
              :options="Object.values(cancelReasons)"
              class="form-control"
              placeholder="Bir sebep seçiniz"
              required
            />
          </div>

          <button
            class="btn btn-primary"
            @click="
              moveOrder(
                selectedOrder.id,
                selectedOrder.integrationOrderId,
                selectedStatus
              )
            "
          >
            Tamam
          </button>
          <button class="btn btn-secondary" @click="closePopup">İptal</button>
        </div>
      </div>
      <div
        style="
          z-index: 999;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        "
        class="popup-overlay"
        v-if="showPopupDetailFlag"
      >
        <div
          style="
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            overflow-y: auto;
          "
          class="popup"
        >
          <h3>Sipariş Detayı</h3>
          <p>Açıklama: {{ orderDetail.description }}</p>
          <table class="ana">
            <tr>
              <td>
                <table>
                  <thead>
                    <td>Ürün</td>
                    <td>Miktar</td>
                    <td>Reçete</td>
                    <td>Ekstralar</td>
                  </thead>
                  <tbody>
                    <tr
                      v-for="entry in orderDetail.cartEntries"
                      :key="entry.id"
                    >
                      <td>{{ entry.productName }}</td>
                      <td>x{{ entry.quantity }}</td>
                      <td>{{ entry.description }}</td>
                      <td>
                        <table>
                          <tr
                            v-for="extra in groupExtras(entry.extras)"
                            :key="index"
                            v-if="extra.quantity > 0"
                          >
                            <td>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {{ extra.name }}
                            </td>
                            <td>x{{ extra.quantity }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
          <div class="row">
            <div class="col-6">
                <p
                  v-if="
                    orderDetail.paymentInformations &&
                    orderDetail.paymentInformations.length > 0
                  "
                  style="margin: 10px 0"
                >
                  <strong>Ödeme Yöntemi:</strong>
                  <span>{{ orderDetail.paymentInformations[0].paymentMethod.name }}</span>
                </p>
                <p>
                  <strong>Adres:</strong>
                  {{ orderDetail.deliveryModel.address }}
                </p>
                <p>
                  <strong>Apartman No:</strong>
                  {{ orderDetail.deliveryModel.apartmentNumber }}
                </p>
                <p>
                  <strong>Kat:</strong> {{ orderDetail.deliveryModel.floor }}
                </p>
                <p>
                  <strong>Kapı No:</strong>
                  {{ orderDetail.deliveryModel.doorNo }}
                </p>
                <p>
                  <strong>Şehir:</strong> {{ orderDetail.deliveryModel.city }}
                </p>
                <p>
                  <strong>İlçe:</strong>
                  {{ orderDetail.deliveryModel.district }}
                </p>
                <p>
                  <strong>Açıklama:</strong>
                  {{ orderDetail.deliveryModel.description }}
                </p>
                <p>
                  <strong>Telefon:</strong>
                  {{ orderDetail.deliveryModel.phoneNumber }}
                </p>
                <p>
                  <strong>Kapı Çalınmasın:</strong>
                  {{
                    orderDetail.deliveryModel.doNotKnockDoor ? "Evet" : "Hayır"
                  }}
                </p>
                <p>
                  <strong>Kapıya Bırak:</strong>
                  {{
                    orderDetail.deliveryModel.dropOffAtDoor ? "Evet" : "Hayır"
                  }}
                </p>
                <p>
                  <strong>Doğrulama Kodu:</strong>
                  {{ orderDetail.confirmationNumber }}
                </p>
              </div>
            </div>
            <div class="col-6">
              <p>Toplam Tutar: {{ orderDetail.totalPrice }}</p>
              <p>
                Toplam İndirim:
                {{ orderDetail.totalCampaignDiscountAmount }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <button class="btn btn-warning" @click="closePopup">Kapat</button>
              <button class="btn btn-warning" @click="printing">Yazdır</button>
            </div>
            <!-- <div class="col-1">
              <vs-button
                type="gradient"
                color="danger"
                icon-pack="feather"
                icon="icon-chevrons-left"
                @click="
                  showPopup(
                    order.id,
                    order.integrationOrderId,
                    orderDetail.orderStatus - 1
                  )
                "
                ><div full-width></div
              ></vs-button>
            </div>
            <div class="col-1">
              <vs-button
                type="gradient"
                color="success"
                icon-pack="feather"
                icon="icon-chevrons-right"
                @click="
                  showPopup(
                    order.id,
                    order.integrationOrderId,
                    orderDetail.orderStatus + 1
                  )
                "
                ><div full-width></div
              ></vs-button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="popup-overlay" v-if="showQrReader">
        <div class="popup">
          <h3>Qr Kodu Tarayabilirsiniz</h3>
          <p>Sipariş ID:</p>
          <vs-row>
            <vs-col vs-w="3"></vs-col>
            <vs-col vs-type="center" vs-w="6" class="p-2">
              <div class="w-full text-center img-border p-5">
                <img src="@/assets/general/qr-code-scan.svg" class="w-full" />
              </div>
            </vs-col>
            <vs-col vs-w="3"></vs-col>
          </vs-row>

          <vs-row vs-type="flex" vs-w="12">
            <input
              autocomplete="off"
              id="qrCode"
              name="Qr Kod"
              ref="qrInput"
              placeholder="Qr Kod"
              class="w-full text-dark weight-600 text-small border-all border-grey low-border-radius px-2"
              v-model="qrCode"
            />
            <span
              class="text-danger text-xsmaller"
              v-show="errors.has('Qr Kod')"
              >{{ errors.first("Qr Kod") }}</span
            >
          </vs-row>
          <!-- <button class="btn btn-primary">Tamam</button> -->
          <button class="btn btn-secondary" @click="closeQrReader">
            İptal
          </button>
          <div v-if="qrCodeOrderData != null">
            <table>
              <thead>
                <tr>
                  <th>Sipariş ID</th>
                  <th>Sipariş İçeriği</th>
                  <th>Sipariş Saati</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ qrCodeOrderData.id }}</td>
                  <td>
                    <table>
                      <thead>
                        <tr>
                          <th>Ürün</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="product in qrCodeOrderData.cartEntries">
                          <th>{{ product.productName }}</th>
                          <th></th>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>{{ qrCodeOrderData.deliveryDateString }}</td>
                  <td>
                    <button
                      class="btn btn-success"
                      @click="showPopup(order.id, order.integrationOrderId, 3)"
                    >
                      Teslim Et
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<style>
.kanban-board {
  display: flex;
  justify-content: space-between;
}

.kanban-column {
  flex: 1;
  margin: 0 10px;
  border-right: 1px solid #ccc;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

th,
td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 5px;
}

.btn-primary {
  background-color: #3399ff;
  color: #fff;
}

.btn-success {
  background-color: #00cc66;
  color: #fff;
}

.btn-warning {
  background-color: #ffcc00;
  color: #fff;
}
.btn-danger {
  background-color: #ff1500;
  color: #fff;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  width: 400px;
  text-align: center;
}

.popup button {
  margin-top: 10px;
}

.warning {
  animation: blinker 1s linear infinite;
  color: red;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>

<script>
import {
  getOrders,
  changeOrderStatus,
  getCancelReasons,
} from "@/api/Integration.js";
import MobileOrderCard from "./MobileOrderCard.vue";
import Printer from "./Printer.vue";
import signalRService from "@/SignalRService";
export default {
  props: {
    orderListIsActive: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    MobileOrderCard,
    Printer,
  },
  inject: ["refreshOrderQuantity"],
  data() {
    return {
      orders: [],
      showPopupFlag: false,
      showPopupDetailFlag: false,
      selectedOrder: null,
      selectedStatus: "",
      changeStatusOrder: {
        orderId: null,
        orderStatus: null,
      },
      showQrReader: false,
      qrCode: "",
      qrCodeOrderData: null,
      orderDetail: null,
      printeractive: false,
      currentDate: "",
      cancelReasons: [],
      cancelReasonString: "",
    };
  },
  mounted: function () {
    // SelfService.vue'dan SignalR bağlantısını kullanacağız
    // Farklı bir bağlantı oluşturmaya gerek yok
    setInterval(() => {
      const activeOrders = this.orders.filter(
        (f) => f.orderStatus != 3 && f.orderStatus != -1
      );
      if (activeOrders.length === 0) return;

      this.orders
        .filter((f) => f.orderStatus != 3 && f.orderStatus != -1)
        .forEach((order) => {
          if (order.deliveryDateString == null) {
            order.deliveryDateString = "00:00";
          }
          order.tableId = this.calculateRemainingSeconds(
            parseInt(order.deliveryDateString.split(":")[0]),
            parseInt(order.deliveryDateString.split(":")[1]),
            order.deliveryDate
          );
        });
    }, 1000);
    setInterval(() => {
      this.orders.forEach((order) => {
        order.tableId -= 1;
      });
    }, 1000);
  },
  computed: {
    orderListIsActiveLocal: {
      get() {
        return this.orderListIsActive;
      },
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    calculateRemainingSeconds(hour, minute, deliveryDate) {
      const now = new Date();
      if (now > new Date(deliveryDate)) {
        return -999;
      }
      const target = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hour,
        minute,
        0
      );
      const diff = target - now;
      const tableId = Math.floor(diff / 1000);
      return tableId;
    },
    remainingTime(tableId) {
      if (tableId <= 0) {
        return "Geçti";
      }
      const remainingHours = Math.floor(tableId / 3600);
      tableId %= 3600;
      const remainingMinutes = Math.floor(tableId / 60);
      tableId %= 60;
      return `${remainingMinutes}:${tableId}`;
    },
    groupExtras(extras) {
      const result = {};
      extras.forEach((extra) => {
        if (extra.variants != null && extra.variants.length > 0) {
          extra.variants.forEach((variant) => {
            if (!result[variant.name]) {
              result[variant.name] = {
                name: variant.name,
                quantity: 0,
              };
            }
            result[variant.name].quantity += variant.quantity;
          });
        } else {
          if (!result[extra.name]) {
            result[extra.name] = {
              name: extra.name,
              quantity: 0,
            };
          }
          result[extra.name].quantity += extra.quantity;
        }
      });
      return Object.values(result);
    },
    initValues() {
      this.qrCode = "";
    },
    showPopup(orderId, integrationOrderId, status) {
      if (orderId == null || orderId == 0) {
        this.selectedOrder = this.orders.find(
          (order) => order.integrationOrderId === integrationOrderId
        );
      } else
        this.selectedOrder = this.orders.find((order) => order.id === orderId);

      if (status == -1) {
        getCancelReasons(integrationOrderId)
          .then((response) => {
            // response.data is an object with key-value pairs
            this.cancelReasons = Object.entries(response.data).map(
              ([key, value]) => ({
                label: value,
                value: key,
              })
            );
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: error.response.data.Errors[0].Message,
            });
          });
      }
      this.selectedStatus = status;
      this.showPopupFlag = true;
    },
    showPopupDetail(order) {
      this.showPopupDetailFlag = true;
      this.orderDetail = order;
      this.printeractive = true;
    },
    showPopupDetail2(orderId, integrationOrderId) {
      let order = this.orders.find((o) => o.id === orderId);
      if (orderId == null || orderId == 0)
        order = this.orders.find(
          (order) => order.integrationOrderId === integrationOrderId
        );

      let i = 0;
      order.cartEntries.forEach((element) => {
        element.id = i.toString();
        i++;
      });

      console.log(order);

      this.showPopupDetailFlag = true;
      this.printeractive = true;
      this.orderDetail = order;
    },
    readQr() {
      this.showQrReader = true;
      this.$nextTick(() => {
        this.$refs.qrInput.focus();
      });
    },
    closePopup() {
      this.printeractive = false;
      this.showPopupFlag = false;
      this.showPopupDetailFlag = false;
    },
    printing() {
      this.getFullTime();
      this.$refs.printer.printOrders();
    },
    closeQrReader() {
      this.showQrReader = false;
      this.initValues();
    },
    moveOrder(orderId, integrationOrderId, status) {
      let orderIndex = 0;
      if (orderId == null || orderId == 0)
        orderIndex = this.orders.findIndex(
          (order) => order.integrationOrderId === integrationOrderId
        );
      else orderIndex = this.orders.findIndex((order) => order.id === orderId);

      this.changeStatusOrder.orderId = this.selectedOrder.id;
      this.changeStatusOrder.integrationOrderId =
        this.selectedOrder.integrationOrderId;
      this.changeStatusOrder.status = status;
      if (status == -1) {
        this.changeStatusOrder.cancelNote = this.cancelReasonString.label;
        this.changeStatusOrder.cancelReason = this.cancelReasonString.value;
      }

      changeOrderStatus(this.changeStatusOrder)
        .then((response) => {
          if (!response.data) {
            this.$vs.notify({
              color: "danger",
              title: "Başarısız",
              text: "Sipariş durumu değiştirilemedi",
            });
            return;
          }
          this.getOrder();

          this.orders[orderIndex].orderStatus = status;
          if (status == -1 || status == 3) {
            // Try to refresh directly first
            try {
              this.refreshOrderQuantity();
            } catch (error) {
              console.error("Error calling refreshOrderQuantity:", error);
            }
            // Still emit the event for backward compatibility
            this.$emit("emitRefresh");
          }
          if (status == 3) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Sipariş teslim edildi",
            });
          }
          if (status == -1) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Sipariş iptal edildi",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Başarısız",
            text: error.response.data.Errors[0].Message,
          });
        });
      this.qrCodeOrderData = null;
      this.qrCode = "";
      this.showQrReader = false;
      this.initValues();
      this.closePopup();
    },
    getOrder: async function () {
      this.orders = (await getOrders()).data;
      this.orders.sort(function (a, b) {
        return new Date(a.deliveryDate) - new Date(b.deliveryDate);
      });
    },
    getFullTime() {
      const date = new Date();
      const options = {
        timeZone: "Europe/Istanbul",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      };
      this.currentDate = date.toLocaleString("tr-TR", options);
    },
    qrCodeReadFunc: async function (val) {
      try {
        var qrresult = await qrCodeRead(val);
        if (qrresult.result == false) {
          this.$fire({
            title: "Bulunamadı ! ",
            text: qrresult.errors[0].message,
            type: "error",
          });
        } else {
          this.qrCodeOrderData = qrresult.data;
        }
      } catch (e) {
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
      }
    },
    closeOrderList() {
      this.orderListIsActiveLocal = false;
    },
  },
  created: async function () {
    this.orders = (await getOrders()).data;
    this.orders.sort(function (a, b) {
      return new Date(a.deliveryDate) - new Date(b.deliveryDate);
    });

    // Listen for SignalR events using the service
    signalRService.on("can-not-integrated-order", (message) => {
      let messageText = "Siparişi alınamadı";
      if (message == 0) {
        messageText = "Getir " + messageText;
      } else if (message == 1) {
        messageText = "Trendyol Go " + messageText;
      } else if (message == 2) {
        messageText = "Yemeksepeti " + messageText;
      }

      this.$vs.notify({
        color: "danger",
        title: "Sipariş alınamadı",
        text: messageText,
      });
    });

    // Listen for SignalR events using the service
    signalRService.on("SendOrder", () => {
      this.getOrder(); // Refresh the orders to ensure we have the latest data
    });

    // Ensure cleanup when component is destroyed
    this.$once("hook:beforeDestroy", () => {
      signalRService.off("SendOrder");
    });
  },
  watch: {
    qrCode(val) {
      this.qrCodeOrderData = null;
      if (val && val.length == 10) {
        this.qrCodeReadFunc(val);
      }
    },
  },
};
</script>
